import Alpine from 'alpinejs';
import tippy from 'tippy.js';

Alpine.data('iconTooltip', () => ({
    init () {
        const content = this.$root.innerHTML.trim();
        if (!content || content === '&nbsp;') {
            return;
        }
        this.$root.classList.add('icon-tooltip--has-content');
        this.$root.setAttribute('role', 'button');
        this.instance = tippy(this.$root, {
            allowHTML: true,
            content: content,
            hideOnClick: false,
            delay: [0, 300],
            interactiveDebounce: 75,
            maxWidth: 350,
        });
    },
}));
